/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  DateSpan,
  DateSpanFromJSON,
  DateSpanFromJSONTyped,
  DateSpanToJSON,
  SubCampaign,
  SubCampaignFromJSON,
  SubCampaignFromJSONTyped,
  SubCampaignToJSON,
} from "./";

/**
 *
 * @export
 * @interface Campaign
 */
export interface Campaign {
  /**
   *
   * @type {number}
   * @memberof Campaign
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof Campaign
   */
  operator: string;
  /**
   *
   * @type {Array<string>}
   * @memberof Campaign
   */
  channels: Array<string>;
  /**
   *
   * @type {string}
   * @memberof Campaign
   */
  targetGroup: string;
  /**
   *
   * @type {DateSpan}
   * @memberof Campaign
   */
  period: DateSpan;
  /**
   *
   * @type {Array<SubCampaign>}
   * @memberof Campaign
   */
  subCampaigns: Array<SubCampaign>;
}

export function CampaignFromJSON(json: any): Campaign {
  return CampaignFromJSONTyped(json, false);
}

export function CampaignFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Campaign {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: !exists(json, "id") ? undefined : json["id"],
    operator: json["operator"],
    channels: json["channels"],
    targetGroup: json["targetGroup"],
    period: DateSpanFromJSON(json["period"]),
    subCampaigns: (json["subCampaigns"] as Array<any>).map(SubCampaignFromJSON),
  };
}

export function CampaignToJSON(value?: Campaign | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    operator: value.operator,
    channels: value.channels,
    targetGroup: value.targetGroup,
    period: DateSpanToJSON(value.period),
    subCampaigns: (value.subCampaigns as Array<any>).map(SubCampaignToJSON),
  };
}
